import "../styles/job.css";

import FeaturesSection from "../pages/FeaturesSection";
import ScrollingFeedback from "../pages/ScrollingFeedback";
import GenAIJobRoles from "../pages/GenAIJobRoles";
import Demand from "../pages/Demand";
import GenAI from "../pages/GenAI"; // hero page

export default function GenAIOverview() {
  return (
    <>
      {/* HERO PAGE */}
      <GenAI />

      {/* MAIN CONTENT */}
      <section className="genai-page">

        {/* HERO TEXT */}
        <header className="genai-hero">
          <h1>Gen AI Starter Program</h1>
         
        </header>

        {/* PROGRAM OVERVIEW */}
        <section className="genai-section">
          <p>
            The Gen AI Starter Program equips learners with essential skills to
            build applications using Generative AI technologies. The program
            introduces Large Language Models (LLMs), prompt engineering,
            embeddings, vector databases, and LangChain integration.
          </p>

          <p>
            Participants will learn how to connect knowledge sources with LLMs
            to create intelligent, context-aware solutions such as AI chatbots
            and knowledge assistants. By the end of the program, learners will
            be able to design prompts, integrate LLM APIs, perform semantic
            search using embeddings, and build a functional
            Retrieval-Augmented Generation (RAG) based AI assistant.
          </p>
        </section>

        {/* JOB ROLES */}
        <GenAIJobRoles />

        {/* INDUSTRY DEMAND */}
        <Demand />

        {/* KEY LEARNING OUTCOMES */}
        <section className="genai-section">
          <h2>Key Learning Outcomes</h2>
          <ul className="outcome-list">
            <li>Understand how LLMs generate responses and how to control them through prompts</li>
            <li>Generate embeddings and perform semantic search on custom datasets</li>
            <li>Store knowledge using vector databases for fast contextual retrieval</li>
            <li>Integrate LLMs, embeddings, and retrieval pipelines using LangChain</li>
            <li>Build and deploy an AI Knowledge Assistant capable of answering real user queries</li>
          </ul>
        </section>

        {/* WHO SHOULD ATTEND */}
       <section className="genai-section">
  <h2>Who Should Attend</h2>
  <ul className="outcome-list">
    <li>Students and fresh graduates exploring AI careers</li>
    <li>Beginners curious about Generative AI and tools like ChatGPT</li>
    <li>Working professionals from non-technical backgrounds</li>
    <li>Developers, designers, marketers, and content creators</li>
    <li>Entrepreneurs and founders looking to leverage AI</li>
  </ul>

  <p className="salary-note">
    No prior coding or AI experience is required — just curiosity to learn.
  </p>
</section>

        {/* CAREER PATHWAYS */}
        <section className="genai-section">
          <h2>Career Pathways, Job Roles & Salary Range in India</h2>

          <div className="salary-table-wrapper">
            <table className="salary-table">
              <thead>
                <tr>
                  <th>Job Role</th>
                  <th>*Entry Salary</th>
                  <th>*Mid-Level Salary</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Generative AI Developer</td><td>₹4.5 – 8 LPA</td><td>₹8 – 18 LPA</td></tr>
                <tr><td>Prompt Engineer</td><td>₹5 – 10 LPA</td><td>₹12 – 28 LPA</td></tr>
                <tr><td>AI Application Developer</td><td>₹5 – 9 LPA</td><td>₹10 – 20 LPA</td></tr>
                <tr><td>LLM Integration Engineer</td><td>₹6 – 12 LPA</td><td>₹15 – 30 LPA</td></tr>
                <tr><td>RAG / Vector Database Engineer</td><td>₹6 – 14 LPA</td><td>₹14 – 32 LPA</td></tr>
                <tr><td>AI Product Analyst</td><td>₹4 – 7 LPA</td><td>₹7 – 15 LPA</td></tr>
                <tr><td>AI Chatbot Developer</td><td>₹4 – 8 LPA</td><td>₹8 – 18 LPA</td></tr>
              </tbody>
            </table>

            <p className="salary-note">
              *Salary ranges vary based on skills, projects, location, and
              industry demand.
            </p>
          </div>
        </section>

        {/* PROJECT HIGHLIGHT */}
        <section className="genai-section highlight">
          <h2>Project Highlight</h2>
          <p>
            <strong>AI Knowledge Assistant:</strong> A context-aware chatbot
            that uses vector search and LLMs to answer questions using custom
            organizational or course data.
          </p>
        </section>

        {/* FEATURES */}
        <FeaturesSection />

        {/* SCROLLING FEEDBACK */}
        <ScrollingFeedback />

      </section>
    </>
  );
}
